import React from "react";
import { Textarea as ChakraTextarea } from "@chakra-ui/react";
export function Textarea({ resize = "vertical", ...props }) {
    return (React.createElement(ChakraTextarea, { focusBorderColor: "forest", resize: resize, ...props }));
}
